export class EquipmentLongTermStatus {
    id = 0;

    effectiveDate = new Date();

    expirationDate = null;

    longTermStatusId = 0;

    equipmentId = 0;
}
